import { existsSync } from "fs";
import { createRequire } from "module";
import { dev } from "./dev";
async function getLatestVersion(packageName) {
  var require2 = createRequire(import.meta.url);
  var _confuseDepCheck = require2;
  var packageJson = _confuseDepCheck("one/package.json");
  var currentVersion = packageJson.version;
  try {
    var response = await fetch(`https://registry.npmjs.org/${packageName}`);
    var data = await response.json();
    var latest = data["dist-tags"].latest;
    if (latest && currentVersion !== latest) {
      console.info(`
\u2776 Update available: ${currentVersion} \u2192 ${latest}`);
      console.info('Run "npx one@latest" or "npm install -g one@latest" to update globally.\n');
    }
  } catch (error) {
    console.error("Failed to fetch the latest version:", error);
  }
}
async function cliMain() {
  var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  void getLatestVersion("one");
  if (existsSync("vite.config.ts")) {
    await dev({});
    process.exit(0);
  }
  var { create } = await import("create-vxrn/create");
  await create(args);
}
export {
  cliMain
};
//# sourceMappingURL=main.js.map
